var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAiGeneratorIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "M12.742 11.464c-2.509 0-4.609-2.228-4.609-4.964q0-.19-.175-.19-.174 0-.175.19c0 2.736-2.041 4.964-4.608 4.964q-.175 0-.175.19 0 .192.175.191c2.508 0 4.608 2.228 4.608 4.964q0 .19.175.191.175 0 .175-.19c0-2.737 2.042-4.964 4.609-4.964q.175 0 .175-.191a.194.194 0 0 0-.175-.191m4.083-5.346c-1.517 0-2.742-1.336-2.742-2.927q0-.19-.175-.191-.174 0-.175.19c0 1.592-1.225 2.928-2.741 2.928q-.175 0-.175.191 0 .19.175.191c1.516 0 2.741 1.336 2.741 2.927q0 .191.175.191t.175-.19c0-1.592 1.225-2.928 2.742-2.928Q17 6.5 17 6.31q0-.192-.175-.192"
})));
export default SvgAiGeneratorIcon;